/* eslint-disable no-misleading-character-class */
/* eslint-disable no-param-reassign */

// ------------------------------------------------------------------------------------------------------- CONSTANT
const space = "\u0020\u200c"; // Spaces
const underscore = "\u005F"; // _
const dash = "\u002D"; // -
const symbol1 = "\u060C"; // ،
const symbol2 = "\u061B"; // ؛
const symbol3 = "\u061F"; // ؟
const symbol4 = "\u066A\u0025"; // %
const symbol5 = "\u066B\u002C"; // ,
const symbol6 = "\u066C"; // !
const symbol7 = "\u0022"; // "
const symbol8 = "\u0027"; // '
const symbol9 = "\u0028"; // (
const symbol10 = "\u0029"; // )
const symbol11 = "\u002E"; // .
const symbol12 = "\u003A"; // :
const symbol13 = "\u003F"; // ?

const symbols = `${dash}${underscore}${symbol1}${symbol2}${symbol3}${symbol4}${symbol5}${symbol6}${symbol7}${symbol8}${symbol9}${symbol10}${symbol11}${symbol12}${symbol13}`;

const motions = "\u064B-\u0651"; // ً  ٌ  ٍ  َ	  ُ	  ِ	  ّ
// const motionsList2 = [/ َ/g, / ُ/g, / ِ/g, / ّ/g, /ً/g, / ٌ/g, / ٍ/g];
const motionsList = ["َ", "ُ", "ِ", "ّ", "ً", "ٌ", "ٍ"];

const persianNumbers = "\u06F0-\u06F9"; // ۰ ۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹
const arabicNumbers = "\u0660-\u0669"; // ۰ ۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹
const persianNumbersList = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
const arabicNumbersList = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];

const persian1 = "\u0621-\u0628"; // ء آ أ	ؤ	إ	ئ	ا ب
const persian2 = "\u062A-\u063A"; // ت  ث  ج  ح  خ  د  ذ  ر  ز  س  ش  ص  ض  ط  ظ  ع  غ
const persian3 = "\u0641-\u0642"; // ف  ق
const persian4 = "\u0644-\u0648"; // ل م ن ه و
const persian5 = "\u06CC\u064A\u0649"; // ی
const persian6 = "\u0655"; //  ٕ
const persian7 = "\u067E"; // پ
const persian8 = "\u0686"; // چ
const persian9 = "\u0698"; // ژ
const persian10 = "\u06A9\u0643"; // ک
const persian11 = "\u06AF"; // گ
const persian12 = "\u06BE\u06D5\u0629"; // ھ

const persianLetter = `${persian1}${persian2}${persian3}${persian4}${persian5}${persian6}${persian7}${persian8}${persian9}${persian10}${persian11}${persian12}`;

const regDate = `(([1-2][0-9]{3})/(0[1-9]|1[0-2])/(0[1-9]|[1-2][0-9]|3[0-1]))`;
const regTime = `([0-9]{1,2}):([-]{0,1})([0-9]{1,2})`;

const isPerstionLetterNumber = (str) => {
  const reg = new RegExp(
    `^[${space}${persianNumbers}${arabicNumbers}0-9${persianLetter}${motions}]*$`
  );

  return reg.test(str);
};
const isPerstionLetter = (str) => {
  const reg = new RegExp(`^[${space}${persianLetter}]*$`);

  return reg.test(str);
};
const isPerstionLetterSymbol = (str) => {
  const reg = new RegExp(
    `^([${persianLetter}${space}${symbols}${motions}]){2,}$`
  );

  return reg.test(str);
};
const isPerstionLetterNumberSymbol = (str) => {
  const reg = new RegExp(
    `^([${persianLetter}${space}${symbols}${persianNumbers}${arabicNumbers}${motions}]){2,}$`
  );

  return reg.test(str);
};
const isFullName = (str) => {
  const reg = new RegExp(
    `^([${persianLetter}]){2,}([${space}]){1}(([${persianLetter}]){1,}(([${space}]){1}([${persianLetter}]){1,}){1,}|([${persianLetter}]){2,})$`
  );

  return reg.test(str);
};
const isNumber = (str) => {
  const reg = new RegExp(`^([0-9${persianNumbers}${arabicNumbers}]){1,}$`);

  return reg.test(str);
};
const isDate = (str) => {
  const reg = new RegExp(`${regDate}`);
  return reg.test(str);
};
const isTime = (str) => {
  const reg = new RegExp(`${regTime}`);
  return reg.test(str);
};
const isDateTime = (str) => {
  const reg = new RegExp(`${regDate} ${regTime}`);
  return reg.test(str);
};
const isTimeDate = (str) => {
  const reg = new RegExp(`${regTime} ${regDate}`);
  return reg.test(str);
};
const isDayTime = (str) => {
  const reg = new RegExp(`([0-9]{1,}) ${regTime}`);
  return reg.test(str);
};
// =========================================================================================================== DEV
const isEmail = (str) => {
  const reg = new RegExp("^[a-zA-Z0-9._]{2,}@[a-zA-Z]{2,}.[a-zA-Z]{2,}$");

  return reg.test(str);
};
const isAddress = (str) => {
  const s = `${symbol2}${symbol3}${symbol4}${symbol6}${symbol7}${symbol8}${symbol9}${symbol10}${symbol11}${symbol12}${symbol13}`;
  const reg = new RegExp(`(.[${s}].)|([${s}].)|(.[${s}])|([${s}])`);

  return !reg.test(str);
};
module.exports = {
  isPerstionLetterNumber,
  isPerstionLetter,
  isPerstionLetterSymbol,
  isPerstionLetterNumberSymbol,
  isFullName,
  isNumber,
  isDate,
  isTime,
  isDateTime,
  isTimeDate,
  isDayTime,
  isEmail,
  isAddress,
};
